// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"d0387aa0","203":"96fef82e","453":"e09926b7","530":"c2a8043e","584":"e7f6bece","638":"bde00672","744":"115773a2","920":"2221a69a","997":"e34f8406"}[chunkId] + ".chunk.js";
};